// src/router/reg-exp-router/index.ts
import { RegExpRouter } from "./router.js";
import { PreparedRegExpRouter, buildInitParams, serializeInitParams } from "./prepared-router.js";
export {
  PreparedRegExpRouter,
  RegExpRouter,
  buildInitParams,
  serializeInitParams
};
